import { clickOn } from "../../events/click";
import { load } from "../../events/load";

const initTabs = () => {
    // Tab Switching Logic
    clickOn(".js-product-tab-trigger", (event, trigger) => {
        event.preventDefault();
        
        // 1. Check if already active
        if (trigger.classList.contains("is-active")) return;
        
        const container = trigger.closest(".product-tabs-wrapper");
        
        // 2. Visual Switch (Navigation)
        const navItems = container.querySelectorAll(".js-product-tab-trigger");
        navItems.forEach(el => el.classList.remove("is-active"));
        trigger.classList.add("is-active");

        // 3. Content Switch
        const targetId = trigger.dataset.target;
        const contentItems = container.querySelectorAll(".product-tab-content-item");
        
        contentItems.forEach(item => {
            item.classList.remove("is-active");
            if (item.id === targetId) {
                item.classList.add("is-active");
            }
        });

        // 4. Center active tab in scroll view (Mobile)
        if (window.innerWidth < 992) {
            trigger.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
    });

    // Custom Scrollbar Logic
    const initScrollbar = () => {
        const wrappers = document.querySelectorAll('.product-tabs-wrapper');
        
        wrappers.forEach(wrapper => {
            const nav = wrapper.querySelector('.product-tabs-nav');
            const scrollbarParam = wrapper.querySelector('.product-tabs-scrollbar');
            
            if (!nav || !scrollbarParam) return;

            const updateScrollbar = () => {
                const thumb = scrollbarParam.querySelector('.product-tabs-scrollbar__thumb');
                if (!thumb) return;

                const scrollWidth = nav.scrollWidth;
                const clientWidth = nav.clientWidth;
                const scrollLeft = nav.scrollLeft;

                if (scrollWidth <= clientWidth) {
                    scrollbarParam.style.display = 'none';
                } else {
                    scrollbarParam.style.display = 'block';
                    
                    // Calculate thumb width percentage
                    const thumbWidthPercent = (clientWidth / scrollWidth) * 100;
                    thumb.style.width = `${thumbWidthPercent}%`;
                    
                    // Calculate thumb position percentage
                    const maxScrollLeft = scrollWidth - clientWidth;
                    const maxThumbLeft = 100 - thumbWidthPercent;
                    const thumbLeft = (scrollLeft / maxScrollLeft) * maxThumbLeft;
                    
                    thumb.style.left = `${thumbLeft}%`;
                }
            };

            nav.addEventListener('scroll', updateScrollbar);
            window.addEventListener('resize', updateScrollbar);
            
            // Initial call
            updateScrollbar();
        });
    };

    initScrollbar();
};

load(initTabs);
